import { FC } from "react";
import styles from "./ListProjectBanner.module.css";
import clsx from "clsx";
import { routesEnum } from "pages/Routes";
import { Link } from "react-router-dom";
import { useUser } from "api/auth";
import { GradientButton } from "components/GradientButton";

const ListProjectBanner: FC = () => {
  const { data: me } = useUser();

  return (
    <div className={styles.root}>
      <div className={clsx("container", styles.content)}>
        <img className={styles.left} src="/images/project/project_left.png" />
        <img className={styles.right} src="/images/project/project_right.png" />
        <h1>
          Explore projects from <br /> Portfolios & <b>hackathons</b>
        </h1>
        <Link
          to={
            me?.userName
              ? `${routesEnum.portfolio}/${me?.userName}?action=add-project`
              : `${routesEnum.signIn}?redirect=add-project`
          }
        >
          <GradientButton size="large">Add Your Project</GradientButton>
        </Link>
      </div>
    </div>
  );
};

export default ListProjectBanner;
